import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioActions } from '../../../../elevio.actions';
import { elevioSelectors } from '../../../../elevio.reducer/selectors';
import { ArticleSuggestion } from '../../../../types';
import { isValidSearchLength } from '../../../../utils';

import { ArticleSelectOptions } from './ArticleSelectOptions';

import { ArticleListWrapper } from './index';

type ResolutionArticleListProps = {
  suggestions?: ArticleSuggestion[];
  searchTerm: string;
  isFetching: boolean;
};
export function ResolutionArticleList({
  suggestions,
  searchTerm,
  isFetching,
}: ResolutionArticleListProps): JSX.Element | null {
  const dispatch = useAppDispatch();
  const articleSearchTerm = useAppSelector(
    elevioSelectors.resolution.articleSearchTerm,
  );
  const articleSearchInputValue = useAppSelector(
    elevioSelectors.resolution.articleSearchInputValue,
  );
  const selectedArticleId = useAppSelector(
    elevioSelectors.resolution.selectedArticleId,
  );

  if (isFetching && articleSearchInputValue.length) {
    return <ArticleListWrapper>Loading...</ArticleListWrapper>;
  }

  if (!suggestions || !suggestions.length) {
    if (
      articleSearchInputValue === articleSearchTerm && // Required to prevent "No articles found" message when the user is still typing
      isValidSearchLength(searchTerm)
    ) {
      return (
        <ArticleListWrapper>
          No articles found, please try a different search phrase.
        </ArticleListWrapper>
      );
    }

    return (
      <ArticleListWrapper>
        Please try a search phrase at least 3 characters long.
      </ArticleListWrapper>
    );
  }

  type OnSelectArticleParams = {
    articleId: string;
    articleTitle: string;
  };
  function onSelectArticle({ articleId, articleTitle }: OnSelectArticleParams) {
    dispatch(
      elevioActions.resolution.setResolutionArticleId({
        articleId,
        articleTitle,
      }),
    );
  }

  return (
    <ArticleListWrapper>
      <ArticleSelectOptions
        suggestions={suggestions}
        selectedArticleId={selectedArticleId}
        onSelectArticle={onSelectArticle}
      />
    </ArticleListWrapper>
  );
}
